export enum OrderWorkunitsLabel {
  CUSTOM = 'CUSTOM',
  UPDATED = 'UPDATED',
  ADDED = 'ADDED',
  CANCELLED = 'CANCELLED',
}
